<ds-modal
  class="modal-container ai-chat-modal-container"
  [headerIcon]="showChatHistory() ? undefined : Icons.Sparkles"
  [headerIconGradientIntent]="DsGradients.Ai"
  [modal]="modal"
  [maxWidthPercentage]="90"
  [title]="showChatHistory() ? '' : ('ai_chat_header' | translate)"
  [colorVariant]="DsModalColorVariant.Default"
  [headerIconColor]="DsColors.Primary"
  [titleHeadingStyle]="HeadingStyle"
>
  <div *ds-modal-header-actions class="modal-header-action-buttons">
    @if (showChatHistory()) {
      <button
        ds-button
        [variant]="DsButtonVariants.microActionHorizontalLayout"
        [intent]="DsButtonIntent.default"
        [microActionIcon]="Icons.ChevronLeft"
        [attr.aria-label]="'back' | translate"
        [ds-tooltip]="'back' | translate"
        [tooltipPlacement]="DsTooltipPosition.bottom"
        (click)="onToggleChatHistory()"
        data-test-id="back-to-chat-button"
        type="button"
      >
        {{ 'back' | translate }}
      </button>
    }
    <button
      ds-button
      [variant]="DsButtonVariants.microAction"
      [microActionIcon]="Icons.Plus"
      [attr.aria-label]="'new_chat' | translate"
      [ds-tooltip]="'new_chat' | translate"
      [tooltipPlacement]="DsTooltipPosition.bottom"
      (click)="onNewChat()"
      data-test-id="new-chat-button"
      type="button"
    ></button>
    @if (!showChatHistory()) {
      <button
        ds-button
        [variant]="DsButtonVariants.microAction"
        [microActionIcon]="Icons.Clock"
        [attr.aria-label]="'chat_history' | translate"
        [ds-tooltip]="'chat_history' | translate"
        [tooltipPlacement]="DsTooltipPosition.bottom"
        (click)="onToggleChatHistory()"
        data-test-id="chat-history-button"
        type="button"
      ></button>
    }
    @if (!showChatHistory() && messages.length > 0) {
      <button
        ds-button
        [variant]="DsButtonVariants.microAction"
        [microActionIcon]="Icons.TrashCan"
        [intent]="DsButtonIntent.destructive"
        [attr.aria-label]="'action_delete' | translate"
        [ds-tooltip]="'action_delete' | translate"
        [tooltipPlacement]="DsTooltipPosition.bottom"
        (click)="onDeleteCurrentSession()"
        data-test-id="delete-chat-button"
        type="button"
      ></button>
    }
  </div>
  @if (showChatHistory()) {
    <app-ai-chat-history
      [activeSessionId]="sessionId"
      (sessionSelected)="onSessionSelected($event)"
      (sessionDeleted)="onSessionDeleted($event)"
    ></app-ai-chat-history>
  } @else {
    <div class="chat-content" [class.has-messages]="messages.length > 0">
      <app-ai-chat-messages
        [messages]="messages"
        [status]="status"
        [refreshSampleQuestionsRequest$]="refreshSampleQuestionsRequest$"
        [focusErrorRequest$]="focusErrorRequest$"
        (sampleQuestionClick)="onSampleQuestionClick($event)"
        (retry)="onRetry($event.message, $event.index)"
        (ratingChange)="onRatingChange($event.message, $event.rating)"
      ></app-ai-chat-messages>
      <div *ds-modal-slide-out-footer class="w-100 px-2">
        <app-ai-chat-footer
          [status]="status"
          [messageValue]="messageValue"
          [focusInputRequest$]="focusInputRequest$"
          [clearInputRequest$]="clearInputRequest$"
          (sendMessage)="sendMessage($event)"
        ></app-ai-chat-footer>
      </div>
    </div>
  }
</ds-modal>
